import React from "react"
import {Link} from "react-router-dom"
import moment from "moment"
import './Rescue.css'
import {capitalizeFirstLetter} from "utils/text_utils"
import {getNameFromId} from "utils/text_utils"


export default function Rescue(props) {

    const {rescue} = props

    const getSubjectName = () => {
        if (rescue.subject) {
            var subject = rescue.subject
            if (subject.given_name && subject.family_name) return subject.given_name + ' ' + subject.family_name
            if (subject.given_name) return subject.given_name
            if (subject.family_name) return subject.family_name
        }
        return <span className="missing">Povredna lista</span>
    }

    const getShortId = () => {
        if (rescue.short_id) return rescue.short_id
        return rescue.id || ''
    }

    const getShortName = () => {
        if (!rescue.rescuer) return ""
        return !!rescue.rescuer.nickname ? rescue.rescuer.nickname : rescue.rescuer.given_name
    }

    const getLocation = () => {
        if (!rescue.location)
            return ""
        if (rescue.location.piste && rescue.location.piste.name)
            return rescue.location.piste.name
        if (rescue.location.description)
            return rescue.location.description
        return ""
    }

    const getTime = () => {
        let time = rescue.created
        if (rescue.events && rescue.events.length > 0 && rescue.events[0].time)
            time = rescue.events[0].time
        return time
    }

    const getLocationAndTime = () => {
        const location = getLocation()
        const time = moment(getTime()).calendar()

        if (location)
            return location + ", " + time

        return capitalizeFirstLetter(time)
    }

    const showInjuries = () => {
        if (!rescue.injuries) return null

        if (Array.isArray(rescue.injuries)) {
            return rescue.injuries.map((injury, i) => <div className="info" key={i}>
                {injury.body_part ? <>{injury.body_part}, {injury.type?.toLowerCase()}</> : <>{injury.type}</>}
            </div>)
        }

        const {types, body_parts} = rescue.injuries
        if (types?.length === 1 && body_parts?.length === 1)
            return <div className="info">{body_parts[0]}, {types[0].toLowerCase()}</div>

        return <>
            {types?.length > 0 && <div className="info">{capitalizeFirstLetter(types.join(', ').toLowerCase())}</div>}
            {body_parts?.length > 0 && <div className="info">{capitalizeFirstLetter(body_parts.join(', ').toLowerCase())}</div>}
        </>
    }

    /* Blurred rescue - show minimal placeholder with rescuer */
    if (rescue.blurred) return <div className={`rescue blurred ${!!rescue.submitted && 'submitted'}`}>
        <div className="rescue-tag submitted" title="Zatvorena povredna lista"></div>
        <div className="rescue-tag open" title="Otvorena povredna lista"></div>
        <div className="name"><span className="missing">{getNameFromId(rescue.id)}</span></div>
        <span className="short-id">{getShortId()}</span>
        <span className="short-rescuer">{getShortName()}</span>
        <div className="info">{rescue.area}</div>
    </div>
    

    return <Link className="rescue" to={`/rescue/${rescue.id}`}>
        <div className={`rescue ${!!rescue.submitted && 'submitted'}`}>
            <div className="rescue-tag submitted" title="Zatvorena povredna lista"></div>
            <div className="rescue-tag open" title="Otvorena povredna lista"></div>
            <div className="open-warning">Lista nije<br/>zaključena</div>
            <div className="name">{getSubjectName()}</div>
            <span className="short-id">{getShortId()}</span>
            <span className="short-rescuer">{getShortName()}</span>
            <div className="info">{getLocationAndTime()}</div>
            {showInjuries()}
        </div>
    </Link>
}		

